import { render } from "./Banner.vue?vue&type=template&id=e4870b72&scoped=true&async=true"
import script from "./Banner.vue?vue&type=script&async=true&lang=js"
export * from "./Banner.vue?vue&type=script&async=true&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=e4870b72&scoped=true&lang=scss&async=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4870b72"]])

export default __exports__